import ConfirmMixin from "../mixins/confirm-mixin";

export default {
    mixins: [ConfirmMixin],
    methods: {
        resendConfirmCode() {
            //todo: удалить
            console.log('confirmPhoneForAuthorize')

            this.clearErrors()

            this.$store.dispatch('sendMobilePhoneAuthorizationCode')
                .then((response) => {
                    if (response.status === 'success') {
                        this.startTimer()
                    }
                })
                .catch((errors) => {
                    this.processErrors(errors)
                })
        },
        confirmCode() {
            //todo: удалить
            console.log('confirmPhoneForAuthorize')

            this.clearErrors()
            this.startLoader()

            this.$store.dispatch('checkMobilePhoneAuthorizationCode', this.code)
                .then((response) => {
                    if (response.status === 'success') {
                        this.$store.dispatch('authorizeCustomerByPhone')
                            .then((authResponse) => {
                                location.reload()
                            })
                    }
                })
                .catch((errors) => {
                    this.processErrors(errors)
                })
                .finally(this.stopLoader)
        }
    }
}
